<div class="tags">
    <ng-container *ngFor="let tag of tags">
        <div [class]="tag?.id==selectedTag?.id?'tag selected':'tag'" (click)="selectTag(tag)">
            {{tag.value}}
        </div>
    </ng-container>
</div>